export const propFaqBooking = {
  faqEditor: {
    empty: "Ancora nessuna domanda. Aggiungi la prima così l'agente saprà come rispondere.",
    learnedTooltip: "Risposta aggiunta tramite l'autoapprendimento dell'host",
    learnedBadge: "Appresa",
    removeAttachment: "Rimuovi allegato",
    uploading: "Caricamento…",
    attach: "Allega",
    deleteTooltip: "Elimina",
    addQuestion: "Aggiungi domanda",
    qPlaceholder: "Domanda · es. C'è il parcheggio?",
    aPlaceholder: "Risposta · es. Sì, gratuito proprio fuori.",
    errors: {
      fillBeforeAttach: "Inserisci la domanda e la risposta prima di allegare i file.",
      saveBeforeAttach: "Salva prima per allegare i file.",
      uploadFailed: "Impossibile caricare il file.",
      deleteFailed: "Impossibile eliminare il file.",
    },
  },
  faqSuggestions: {
    title: "Suggerimenti da apprendere",
    intro: "L'agente non è riuscito a rispondere a queste domande e hai risposto tu all'ospite. Rivedile, modificale se necessario e salvale così d'ora in poi l'agente potrà rispondere da solo.",
    askedLabel: "L'ospite ha chiesto",
    questionLabel: "Domanda",
    questionPlaceholder: "Come formuleresti la domanda?",
    answerLabel: "Risposta dell'agente",
    answerPlaceholder: "Risposta che darà l'agente",
    applyToOthers: "Applica anche ad altre unità dell'annuncio:",
    dismiss: "Ignora",
    saveAsAnswer: "Salva come risposta",
    errors: {
      saveFailed: "Impossibile salvare.",
      dismissFailed: "Impossibile ignorare.",
    },
  },
  sourceNote: {
    title: "Ordine di priorità delle risposte dell'agente",
    infoAria: "Visualizza l'ordine di priorità delle fonti dell'agente",
    lead: "Quando due fonti dicono qualcosa di diverso sullo stesso dettaglio, l'agente segue questo ordine:",
    faqPre: "FAQ ",
    faqStrong: "per singola unità",
    faqTag: "prevale",
    configMain: "Impostazioni dell'alloggio",
    configMuted: "· orari, capacità, servizi",
    kb: "Base di conoscenza",
  },
  bookingLinks: {
    title: "Come prenota l'ospite",
    subPre: "L'agente invia il tuo link di ",
    subStrong: "Prenotazioni Dirette",
    subPost: " e l'ospite prenota sul web.",
    step1Pre: "Se indica un ",
    step1Strong: "alloggio specifico",
    step1Post: ", l'agente invia il suo link diretto.",
    step2Pre: "Se ce ne sono ",
    step2Strong1: "diversi in quella zona",
    step2Mid: ", ",
    step2Strong2: "elenca ciascuno con il suo link",
    step2Post: " più quello globale.",
    step3Pre: "Se non conosce la zona, ",
    step3Strong: "suggerisce le zone disponibili",
    step3Post: " e chiede dove desiderano soggiornare.",
    globalLinkLabel: "Link globale (tutte le località)",
    copy: "Copia",
    copied: "Copiato",
    noIdNote: "Il link di prenotazione verrà generato una volta configurato l'identificativo del tuo account.",
    toastCopied: "Link copiato",
    toastCopyFailed: "Impossibile copiare",
  },
  bookingConfirm: {
    title: "Notifica nuova prenotazione",
    subPre: "Quando una prenotazione viene confermata, notifichiamo automaticamente l'ospite ",
    subStrong: "su WhatsApp",
    subPost: " con i dettagli del soggiorno.",
    toggleLabel: "Invia la conferma su WhatsApp",
    toggleHint: "Se lo disattivi, questa notifica non verrà inviata all'ospite. Se la prenotazione proviene da una OTA, sarà l'OTA a notificarlo.",
    stateOn: "Sì, inviala",
    stateOff: "Non inviare",
    notEditablePre: "Per ora, il contenuto di questo messaggio ",
    notEditableStrong: "non è modificabile",
    notEditablePost: ". Ti mostriamo un'anteprima di ciò che riceve l'ospite.",
    previewTag: "Anteprima · ciò che vede l'ospite",
    online: "online",
    today: "Oggi",
    previewHint: "Si aggiorna con la tua configurazione",
    defaultListingName: "Alloggio",
    toastEnabled: "Notifica di prenotazione attivata",
    toastDisabled: "Notifica di prenotazione disattivata",
    toastSaveFailed: "Impossibile salvare la modifica",
    previewGuest: "Laura García",
    previewBody: "Ciao *{guest}* 👋\n\nLa tua prenotazione presso *{name}* è confermata ✅\n\nCodice prenotazione: *6233Q1VC5*\nDate: *05/06/2026* – *07/06/2026* 📅\n\nTramite questo WhatsApp puoi richiedere il link per il check-in online e ricevere anche le istruzioni per l'arrivo.\nSe hai bisogno di aiuto prima o durante il soggiorno, scrivici qui 💬",
    previewCta: "🇪🇸 Per continuare con il check-in, tocca il pulsante *Ok* o scrivi *Ok*.",
  },
};
